import { Heading, Secondary, Text } from '@cinch-labs/design-system'
import { ContentSectionProps as CareersSectionProps } from '@cinch-nx/landing-ui-shared'
import Image from 'next/legacy/image'

import styles from './careers.module.css'

export const CareersSection: React.FC<CareersSectionProps> = (blok) => {
  const { heading, body, image } = blok
  const [CTA] = blok?.CTA || []

  return (
    <section className={styles.wrapper}>
      {image?.filename ? (
        <div className={styles.imageWrapper}>
          <Image
            src={image.filename}
            alt={image.alt ?? undefined}
            layout="fill"
            objectFit="cover"
          />
        </div>
      ) : null}

      <div className={styles.textWrapper}>
        <Heading className={styles.heading}>{heading}</Heading>

        <Text className={styles.body}>{body}</Text>

        {CTA ? (
          <Secondary
            element="a"
            href={CTA.url}
            classNames={{ button: styles.button }}
          >
            {CTA.text}
          </Secondary>
        ) : null}
      </div>
    </section>
  )
}

export default CareersSection
